import { getMonitoredOfferCountsResourceQueryOptions } from "@/components/marketplace/monitored-offer-counts-query";
import { getStoresQueryOptions } from "./stores-query";
const SplitLoader = async ({
  context: {
    queryClient
  }
}) => {
  await Promise.all([queryClient.ensureQueryData({
    ...getMonitoredOfferCountsResourceQueryOptions()
  }).catch(() => null), queryClient.ensureQueryData(getStoresQueryOptions()).catch(() => null)]);
  return null;
};
export { SplitLoader as loader };